import { render, staticRenderFns } from "./totalScoreDetail.vue?vue&type=template&id=42a877f1&scoped=true&"
import script from "./totalScoreDetail.vue?vue&type=script&lang=js&"
export * from "./totalScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./totalScoreDetail.vue?vue&type=style&index=0&id=42a877f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a877f1",
  null
  
)

export default component.exports